import React from 'react'
import ContentLoader from 'react-content-loader'
import classes from './SearchFilterLoader.module.css'

const SearchFilterLoader = () => {
    return (
        <ContentLoader className={classes.loader}>
            <rect width={'100%'} height={'44px'} />
            {[...Array(4)].map((_, idx) => (
                <>
                    <rect
                        width={'10px'}
                        height={'10px'}
                        rx={'2px'}
                        ry={'2px'}
                        x={'22px'}
                        y={`${64 + 22 * idx}px`}
                    />
                    <rect
                        width={'200px'}
                        height={'10px'}
                        rx={'2px'}
                        ry={'2px'}
                        x={'40px'}
                        y={`${64 + 22 * idx}px`}
                    />
                </>
            ))}
        </ContentLoader>
    )
}

export default SearchFilterLoader
